import { Box, Container, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import { usePlatformDocument } from '../../hooks/usePlatformDocument';
import Logo from '../../components/brand/Logo';
import { brand } from '../../theme';

function Footer() {
  const { url: privacyPolicyUrl } = usePlatformDocument('privacy-policy.pdf');
  const { url: websiteTermsUrl } = usePlatformDocument('website-terms.pdf');

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: brand.ink,
        color: brand.paper,
        py: 7,
        mt: 'auto',
        width: '100%',
        borderTop: `1px solid ${brand.darkLine}`,
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Logo tone="onDark" height={35} aria-label="Trade Connector" />
        </Box>
        <Typography variant="h5" align="center" sx={{ color: brand.darkText2, mb: 3, fontWeight: 400 }}>
          Verified Trades. Approved Businesses. Structured Work.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, color: brand.accent }}>
          <EmailIcon fontSize="small" />
          <Link
            href="mailto:info@tradeconnector.com.au"
            sx={{
              color: brand.paper,
              textDecoration: 'none',
              '&:hover': { color: brand.accent, textDecoration: 'underline' },
            }}
          >
            info@tradeconnector.com.au
          </Link>
        </Box>
        <Typography variant="body2" align="center" sx={{ mt: 4, color: brand.darkText3 }}>
          © {new Date().getFullYear()} Trade Connector. All rights reserved.
          <span aria-hidden="true">{' | '}</span>
          <Link
            component={RouterLink}
            to="/about-us"
            sx={{
              color: brand.darkText3,
              textDecoration: 'none',
              '&:hover': { color: brand.accent, textDecoration: 'underline' },
            }}
          >
            About Us
          </Link>
          <span aria-hidden="true">{' | '}</span>
          <Link
            href={privacyPolicyUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: brand.darkText3,
              textDecoration: 'none',
              '&:hover': { color: brand.accent, textDecoration: 'underline' },
            }}
          >
            Privacy Policy
          </Link>
          <span aria-hidden="true">{' | '}</span>
          <Link
            href={websiteTermsUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: brand.darkText3,
              textDecoration: 'none',
              '&:hover': { color: brand.accent, textDecoration: 'underline' },
            }}
          >
            Website Terms
          </Link>
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
